import { CreateIdeaStopFormData, IdeaStopType } from './ideaStop.types';

export const IDEA_STOP_INITIAL_VALUES: CreateIdeaStopFormData = {
  ideaStopType: 'Flight' as IdeaStopType,

  description: '',

  name: '',
  place: '',

  startDate: '',
  startTime: '',
  endDate: '',
  endTime: '',
  departureDate: '',
  departureTime: '',
  arrivalDate: '',
  arrivalTime: '',
  checkInDate: '',
  checkInTime: '',
  checkOutDate: '',
  checkOutTime: '',

  flightFrom: '',
  flightTo: '',
  airline: '',
  flightNumber: '',

  vehicleType: '',
  transportName: '',

  departureLocation: '',
  arrivalLocation: '',
  startingPortName: '',
  endingPortName: '',
  departureStation: '',
  arrivalStation: '',

  countryFrom: '',
  countryTo: '',
  borderCheckpoint: '',

  address: '',
  departureAddress: '',
  arrivalAddress: '',
  startingPortAddress: '',
  endingPortAddress: '',

  shipName: '',

  phone: '',
  email: '',
  link: '',
  notes: '',

  address_details: undefined,
  departureAddress_details: undefined,
  arrivalAddress_details: undefined,
  startingPortAddress_details: undefined,
  endingPortAddress_details: undefined,

  flightFrom_details: undefined,
  flightTo_details: undefined,
  airline_details: undefined,
};

export const getIdeaStopResetValues = (): CreateIdeaStopFormData => {
  return { ...IDEA_STOP_INITIAL_VALUES };
};
